// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__mtte0","description":"PatientConsentPreview_description__1hNpU"};